module.exports = __webpack_public_path__ + "img/blank-booth-white.d3c1e24b.png";